/** Merge translations, replacing empty ones with the value from the fallback. */
export const mergeTranslations = ({
  translations,
  fallback,
}: {
  translations: Record<string, string>
  fallback: Record<string, string>
}) =>
  Object.fromEntries(
    Object.entries(translations).map(([key, value]) => [
      key,
      value || fallback[key] || '',
    ]),
  )
